import React from 'react';
import { GetServerSideProps } from 'next';
import CenteredContainer from '@/common/CenteredContainer';
import GlutenFreePageContent from '@/shared/pages/gluten-free';

import initializePage from '../app/common/pageSetup';

const GlutenFreePage = (): JSX.Element => (
  <>
    <CenteredContainer>
      <GlutenFreePageContent />
    </CenteredContainer>
  </>
);

export const getServerSideProps: GetServerSideProps = (ctx) => initializePage(ctx, 'gluten-free');

export default GlutenFreePage;
